// extracted by mini-css-extract-plugin
export default {"actionFooter":"ActionFooter_actionFooter__1kh-J"};